import { ZeneithDB } from "../ZeneithDB.js";
import { ThreadComm } from "threadcomm";
export class ZeneithError extends Error {
    constructor(message, data) {
        super();
        console.group();
        console.error(`[ZDB ERROR: ${new Date().toLocaleTimeString()}]
   [THREAD: name: ${ThreadComm.threadName} number: ${ThreadComm.threadName} parent : ${ThreadComm.parent.name}]
   ${message}`, data);
        console.table(ZeneithDB.core.loadedDatabases);
        console.groupEnd();
    }
}
